import { SignupViewModel } from '@apis/model';
import { toCaptchaViewModel, toOtpViewModel } from '@apis/responseTransformer';
import { SignupResponse } from '@ul/api';

export const toSignupViewModel = (signupResponse: SignupResponse): SignupViewModel => {
    const { success, responseCode } = signupResponse;
    return {
        responseCode,
        success,
        captchaViewModel: toCaptchaViewModel(signupResponse),
        otpViewModel: toOtpViewModel(signupResponse),
    };
};
